@if (notification$ | async; as notification) {
  <div
    class="notification flex flex-col gap-2 rounded-lg pb-1.5 drop-shadow-md"
  >
    <div
      class="bg-primary-500 flex w-full items-center justify-stretch rounded-t-lg pl-4"
    >
      <pr-content-view
        class="title flex-1 !text-white"
        [content]="notification.title"
      />

      <div class="my-0.5 flex items-center">
        @if (notification.hasTimeout) {
          <mat-progress-spinner
            class="mr-2 !text-white"
            [diameter]="18"
            [value]="progress$ | async"
          />
        }

        @if (notification.notificationSound) {
          @if (isMuted$ | async) {
            <button
              mat-icon-button
              class="!text-white"
              matTooltip="Unmute notification sound"
              (click)="muteNotifications(false)"
            >
              <mat-icon class="icon-sm">volume_off</mat-icon>
            </button>
          } @else {
            <button
              mat-icon-button
              class="!text-white"
              matTooltip="Mute notification sound"
              (click)="muteNotifications(true)"
            >
              <mat-icon class="icon-sm">volume_up</mat-icon>
            </button>
          }
        }

        <button
          mat-icon-button
          class="!text-white"
          aria-label="Close notification"
          (click)="removeNotification(notification, true)"
        >
          <mat-icon class="icon-sm">close</mat-icon>
        </button>
      </div>
    </div>
    <pr-content-view class="-mb-2 px-4" [content]="notification.content" />

    @if (notification.actions?.length) {
      <div class="mb-1 flex justify-end gap-4 px-2">
        @for (action of notification.actions; track action.label) {
          @if (action.style === 'flat') {
            <a
              mat-flat-button
              class="flex-1"
              [color]="action.colour"
              [routerLink]="action.href"
              [fragment]="action.fragment"
              [queryParams]="action.queryParams"
              (click)="removeNotification(notification)"
              >{{ action.label }}</a
            >
          } @else {
            <a
              mat-stroked-button
              class="flex-1"
              [color]="action.colour"
              [routerLink]="action.href"
              [fragment]="action.fragment"
              [queryParams]="action.queryParams"
              (click)="removeNotification(notification)"
              >{{ action.label }}</a
            >
          }
        }
      </div>
    }
  </div>
}
